module.exports = __webpack_public_path__ + "media/2022/scholarships-310d1ac9.png";